export const translateTimeLabel = (value) => {
  switch (value) {
    case "Immédiatement":
      return "Immédiatement";
    case "MoinsHeure":
      return "Moins d'une heure";
    case "MoinsDemiJournée":
      return "Moins d’une demi-journée";
    case "MoinsJournée":
      return "Moins d’une journée";
    case "PlusJournée":
      return "Plus d’une journée";
    default:
      return value || "";
  }
};

export const translateDelaiIndexLabel = (value) => {
  switch (value) {
    case 0:
      return "Immédiatement";
    case 1:
      return "Moins d'une heure";
    case 2:
      return "Moins d’une demi-journée";
    case 3:
      return "Moins d’une journée";
    case 4:
      return "Plus d’une journée";


    default:
      return value || "";
  }
};


export const translateCanalIndexLabel = (value) => {
  switch (value) {
    case 0:
      return "Téléphone";
    case 1:
      return "Mail";
    case 2:
      return "FioManager";
    case 3:
      return "Interne";
    case 4:
      return "Audit";
    default:
      return value || "";
  }
}
